import { getPaymentStatusLabel } from '../utils';
import { PaymentStatus as PaymentStatusEnum } from '../types';
import '@shared/styles/status-tag.css';

const PAYMENT_STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  [PaymentStatusEnum.PENDING]: { bg: '#fef3c7', color: '#92400e' },
  [PaymentStatusEnum.PAID]: { bg: '#22c55e', color: '#fff' },
  [PaymentStatusEnum.FAILED]: { bg: '#ef4444', color: '#fff' },
  [PaymentStatusEnum.REFUNDED]: { bg: '#9ca3af', color: '#1f2937' },
};

const DEFAULT_COLORS = { bg: '#e5e7eb', color: '#374151' };

interface OrderPayStatusProps {
  paymentStatus?: string | PaymentStatusEnum | null;
}

export default function OrderPayStatus({ paymentStatus }: OrderPayStatusProps) {
  const label = paymentStatus != null ? getPaymentStatusLabel(paymentStatus) : 'Не указано';
  const colors = (paymentStatus && PAYMENT_STATUS_COLORS[paymentStatus]) || DEFAULT_COLORS;
  const { bg, color } = colors;
  return (
    <span
      className="status-tag"
      style={{ backgroundColor: bg, color }}
    >
      {label}
    </span>
  );
}
